import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getLastEvents } from '../../../actions/Dashboard/EventsActions';
import { StateType } from '../../../reducers';
import { eventsDataSelector, eventsIsFetchingSelector } from '../../../reducers/DashboardReducer/EventsReducer/EventsSelector';
import { DispatchConnect } from '../../../types/';

import { EventsPropsGeneric, EventsStateDispatchers, EventsStateProps } from './types';
import EventsMain from './EventsMain';

class Events extends React.Component<EventsPropsGeneric> {
  UNSAFE_componentWillMount() {
    this.props.dispatchGetDashboardEvents();
  }

  render() {
    return <EventsMain data={this.props.data} isFetching={this.props.isFetching} />;
  }
}

const mapStateToProps = (state: StateType): EventsStateProps => ({
  // @ts-ignore
  data: eventsDataSelector(state),
  // @ts-ignore
  isFetching: eventsIsFetchingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): EventsStateDispatchers => ({
  dispatchGetDashboardEvents: async () => dispatch(getLastEvents()),
});

export default connect<EventsStateProps, DispatchConnect<EventsStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(Events);
